import { z } from 'zod';
// String values as stored in the database (personal_info.data_subject_requests)
export var OptOutType;
(function (OptOutType) {
    OptOutType["OPT_OUT_SALE"] = "OPT_OUT_SALE";
    OptOutType["OPT_OUT_PROCESSING"] = "OPT_OUT_PROCESSING";
    OptOutType["DELETE"] = "DELETE";
    OptOutType["CHANGE"] = "CHANGE";
    OptOutType["INFO"] = "INFO";
})(OptOutType || (OptOutType = {}));
export var OptOutSource;
(function (OptOutSource) {
    OptOutSource["INTENTSIFY"] = "INTENTSIFY";
    OptOutSource["COOP"] = "COOP";
})(OptOutSource || (OptOutSource = {}));
// Numeric enums used by DTOs (matching proto enum ordinals)
export var OptOutReasonEnum;
(function (OptOutReasonEnum) {
    OptOutReasonEnum[OptOutReasonEnum["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    OptOutReasonEnum[OptOutReasonEnum["OPT_OUT_SALE"] = 1] = "OPT_OUT_SALE";
    OptOutReasonEnum[OptOutReasonEnum["OPT_OUT_PROCESSING"] = 2] = "OPT_OUT_PROCESSING";
    OptOutReasonEnum[OptOutReasonEnum["DELETE"] = 3] = "DELETE";
    OptOutReasonEnum[OptOutReasonEnum["CHANGE"] = 4] = "CHANGE";
    OptOutReasonEnum[OptOutReasonEnum["INFO"] = 5] = "INFO";
})(OptOutReasonEnum || (OptOutReasonEnum = {}));
export var OptOutSourceEnum;
(function (OptOutSourceEnum) {
    OptOutSourceEnum[OptOutSourceEnum["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    OptOutSourceEnum[OptOutSourceEnum["INTENTSIFY"] = 1] = "INTENTSIFY";
    OptOutSourceEnum[OptOutSourceEnum["COOP"] = 2] = "COOP";
})(OptOutSourceEnum || (OptOutSourceEnum = {}));
export const PersonalInfo = z.object({
    first_name: z.string().nonempty().default(''),
    last_name: z.string().nonempty().default(''),
    business_email: z.string().email().nonempty().default(''),
    mobile_phone: z.string().nullable().default(null),
    direct_number: z.string().nullable().default(null),
    job_title: z.string().nonempty().default(''),
    job_level: z.string().nonempty().default(''),
    job_function: z.string().nonempty().default(''),
    company_name: z.string().nonempty().default(''),
    company_domain: z.string().nonempty().default(''),
    linkedin_url: z.string().nonempty().default(''),
});
//# sourceMappingURL=PersonalInfo.js.map